import Box from '@material-ui/core/Box';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Utils from '@/common/utils/utils';
import WarningIcon from '@material-ui/icons/WarningTwoTone';
import crypto from 'crypto-js';
import Constant from '../../common/constant/Constant';
import { getCookieValue } from '@/service/authenService';
import { getRecoil } from 'recoil-nexus';
import { replacedFileTimestampMapAtom } from '@/state/atom/ticketAtom';

export const FileUploaded = (props) => {
    function LinearProgressWithLabel(propProgress) {
        let process = propProgress.value ? Math.round(propProgress.value) : 0;
        return process < 100 ? (
            <Box display="flex" alignItems="center" style={{ marginTop: 2 }}>
                <Box width="100%" mr={1} minWidth={50}>
                    <LinearProgress variant="determinate" color="secondary" {...propProgress} />
                </Box>
                <Box minWidth={35}>
                    <Typography variant="body2" color="secondary">{`${process}%`}</Typography>
                </Box>
            </Box>
        ) : null;
    }

    function renderFileUpload() {
        let fileActive = Utils.isEmptyObject(props.fileUploadInfor);
        let fileNameClass = props.isAlignLeft ? 'file-upload-name' : 'file-upload-name--change';
        const lastDot = props.chatPost.content.lastIndexOf('.');
        let fileExtention = ''
        let fileName
        if(props.chatPost.content.substring(0, lastDot).length === 0){
           fileName = props.chatPost.content.length > 50 ?  props.chatPost.content.slice(0,50) + '...' :  props.chatPost.content;
        }else{
            fileExtention = props.chatPost.content.substring(lastDot + 1);
            fileName = props.chatPost.content.substring(0, lastDot).length > 50 ?  props.chatPost.content.substring(0, lastDot).slice(0,50) + '...' : props.chatPost.content.substring(0, lastDot)+'.' ;
        } 

        let renderUploadFiles = [];
        const fileNameAndSize = `${fileName}${fileExtention} (${getFileSizeDisplay(
            props.chatPost.fileSize
        )})`;
        const content = [];
        if (props.chatPost.type === Constant.S3_FILE_TYPE.CHAT_POST_FILE && props.chatPost.postType === Constant.POST_TYPE.IMAGE) {
            let view = Constant.ATTACH_FILE.VIEW_CHAT;
                let dataDownload = getLinkDownloadFileFromS3(props.chatPost, props.detailTicket, props.fileUploadInfor, view);
                content.push(
                    <div className="content-post">
                        <img 
                            src={dataDownload}
                            alt=''
                        />
                    </div>
                );
           
            content.push(<span style={{ display: 'block',wordBreak:'break-word' }}  > {fileNameAndSize} </span>);
        } else {
            content.push(fileNameAndSize);
        }
        let elementChild = (
            <a
                className={fileActive ? `${fileNameClass} file-upload-active` : fileNameClass}
                target="_blank"
                download={props.chatPost.content}
                onClick={() => (fileActive ? downloadFileFromS3(props.chatPost,props.detailTicket, false, false, '', props?.setIsShowPopupLogout) : null)}
            >
                {content}
                {props.fileUploadInfor?.status === false && (
                    <WarningIcon color="error" size="small" />
                )}
            </a>
        );
        renderUploadFiles.push(elementChild);
        if (!Utils.isEmptyObject(props.fileUploadInfor) && props.fileUploadInfor.status) {
            renderUploadFiles.push(
                <LinearProgressWithLabel value={props.fileUploadInfor.progress} />
            );
        } 
        return renderUploadFiles;
    }
    return renderFileUpload();
};

export const getLinkDownloadFileFromS3 = (fileUpload, detailTicket, fileUploadInfor = null, viewPosition, isLinkDownload = false, isPublic = false, pksAffiliationProject = '' ) => {
    if (Utils.isEmptyString(fileUpload?.fileUrl)) {
        return;
    }
    const loadingThumbnail = '/assets/image/thumbnail.png';
    if (!fileUpload.id && fileUpload.type === Constant.S3_FILE_TYPE.CHAT_POST_FILE) {
        return loadingThumbnail;
    }

    let s3Path = fileUpload.fileUrl.replace("public/", "");
    if (isLinkDownload === false) {
        let fileExtention = s3Path.split('.').pop().toLocaleLowerCase();
        // get thumbnail
        if (fileUpload?.thumbnailInfo) {
            let thumbnail = Utils.convertJSONDataToObject(fileUpload?.thumbnailInfo);
            const thumbnailUri = detailTicket?.thumbnailInfo?.thumbnailUri && typeof detailTicket?.thumbnailInfo?.thumbnailUri === 'string' ? detailTicket?.thumbnailInfo?.thumbnailUri : '';
            if (viewPosition === Constant.ATTACH_FILE.VIEW_CHAT) {
                if (thumbnailUri) s3Path = thumbnailUri?.replace("public/", "");
            }
            if (viewPosition === Constant.ATTACH_FILE.VIEW_TICKET) {
                if (thumbnailUri) s3Path = thumbnailUri?.replace("public/", "");
            }
            if (viewPosition === Constant.ATTACH_FILE.VIEW_TICKET_DETAIL) {
                if (thumbnailUri) {
                    s3Path = thumbnailUri?.replace("public/", "");
                }
            }
            if (viewPosition === Constant.ATTACH_FILE.VIEW_PUBLIC_KNOWLEDGE) {
                const fileUploadThumbnailUri = thumbnail?.large?.thumbnailUri || thumbnail?.medium?.thumbnailUri;
                if (fileUploadThumbnailUri && typeof fileUploadThumbnailUri === 'string') {
                    s3Path = fileUploadThumbnailUri.replace("public/", "");
                }
            }
            if (
                fileExtention === 'tiff' || fileExtention === 'tif'
            ) {
                s3Path = loadingThumbnail?.replace("public/", "");
            }
        } else {
            if (fileExtention !== 'tiff' && fileExtention !== 'tif'){
                s3Path = fileUpload.fileUrl.replace("public/", "");
            } else {
                s3Path = loadingThumbnail?.replace("public/", "");
            }
        }
    }

    let uriObj = {};
    let projectList = [];
    let orgHasReadPermission = [];
    let userHasReadPermission = [];

    if (
        fileUpload.type === Constant.S3_FILE_TYPE.TICKET_FILE &&
        [
            Constant.TICKET_TYPE.KNOWLEDGE,
            Constant.TICKET_TYPE.MASTER_KNOWLEDGE,
            Constant.TICKET_TYPE.PDF_FILE_KNOWLEDGE,
            Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE
        ].includes(detailTicket?.ticketType)
    ) {
        const viewPermission = Utils.convertJSONDataToObject(detailTicket.viewPermission);

        let additionalViewPermission = Utils.convertJSONDataToObject(
            detailTicket.additionalViewPermission
        );
        if (!Utils.isEmptyObject(additionalViewPermission)) {
            let b2bCustomerProject = !Utils.isEmptyArray(
                additionalViewPermission.b2bCustomerProject
            )
                ? additionalViewPermission.b2bCustomerProject
                : [];
            let b2bHelpdeskProject = !Utils.isEmptyArray(
                additionalViewPermission.b2bHelpdeskProject
            )
                ? additionalViewPermission.b2bHelpdeskProject
                : [];

            let baseProject = !Utils.isEmptyArray(additionalViewPermission.baseProject)
                ? additionalViewPermission.baseProject
                : [];

            let guestCustomerProject = !Utils.isEmptyArray(
                additionalViewPermission.guestCustomerProject
            )
                ? additionalViewPermission.guestCustomerProject
                : [];

            let orgProject = !Utils.isEmptyArray(additionalViewPermission.orgProject)
                ? additionalViewPermission.orgProject
                : [];

            projectList = [
                ...b2bCustomerProject,
                ...b2bHelpdeskProject,
                ...baseProject,
                ...guestCustomerProject,
                ...orgProject
            ];
        }

        if (!Utils.isEmptyArray(viewPermission)) {
            viewPermission?.forEach(permission => {
                if (permission === Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR_ONLY) {
                    userHasReadPermission.push(detailTicket.creator);
                }
                if (permission === Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT) {
                    projectList.push(detailTicket.affiliationProject);
                }
                if (permission === Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG) {
                    orgHasReadPermission.push(detailTicket.affiliationOrganization);
                }

                if (permission === Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_CUSTOMER) {
                    let activeB2BCustomerList = Utils.convertJSONDataToObject(
                        detailTicket.activeB2BCustomerList
                    );
                    if (!Utils.isEmptyArray(activeB2BCustomerList)) {
                        projectList = [...projectList, ...activeB2BCustomerList];
                    }
                }

                if (permission === Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_SUPPORT) {
                    let activeB2BSupportList = Utils.convertJSONDataToObject(
                        detailTicket.activeB2BSupportList
                    );
                    if (!Utils.isEmptyArray(activeB2BSupportList)) {
                        projectList = [...projectList, ...activeB2BSupportList];
                    }
                }

                if (permission === Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC) {
                    uriObj.publicAll = true;
                }
            });
        }

        uriObj.projectList = projectList;
        uriObj.orgHasReadPermission = orgHasReadPermission;
        uriObj.userHasReadPermission = userHasReadPermission;
        uriObj.keyFile = `/public/${s3Path}`;
    }

    if (fileUpload.type === Constant.S3_FILE_TYPE.TICKET_FILE && ![
        Constant.TICKET_TYPE.KNOWLEDGE,
        Constant.TICKET_TYPE.MASTER_KNOWLEDGE,
        Constant.TICKET_TYPE.PDF_FILE_KNOWLEDGE,
        Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE
    ].includes(detailTicket?.ticketType)) {
        
        if (detailTicket?.affiliationProject) projectList.push(detailTicket.affiliationProject);
        if (!Utils.isEmptyArray(detailTicket?.additionalReadPermission)) {
            projectList = [...projectList, ...detailTicket.additionalReadPermission];
        }
        if (!Utils.isEmptyArray(detailTicket?.additionalCustomers)) {
            projectList = [...projectList, ...detailTicket.additionalCustomers];
        }

        if ([Constant.NOTICE_GROUP_CUSTOMER.ALL_CUSTOMER_PROJECT].includes(detailTicket?.customer)) {
            projectList = [...projectList, ...detailTicket.projectTarget]
        }

        if ('user' === Utils.getPrefixOfId(detailTicket?.customer)) {
            userHasReadPermission.push(detailTicket.customer);
        } else {
            if (detailTicket?.customer) projectList.push(detailTicket.customer);
        }

        if ('corp' === Utils.getPrefixOfId(detailTicket?.readPermission)) {
            orgHasReadPermission.push(detailTicket?.readPermission);
        }

        if ('user' === Utils.getPrefixOfId(detailTicket?.readPermission)) {
            userHasReadPermission.push(detailTicket?.readPermission);
        }
        uriObj = {
            projectList,
            orgHasReadPermission,
            userHasReadPermission,
            keyFile: `/public/${s3Path}`,
        };
        
    }

    if (fileUpload.type === Constant.S3_FILE_TYPE.CHAT_POST_FILE) {
        if (
            [Constant.TICKET_TYPE.KNOWLEDGE, Constant.TICKET_TYPE.MASTER_KNOWLEDGE].includes(
                detailTicket?.ticketType
            )
        ) {
            const viewPermission = Utils.convertJSONDataToObject(detailTicket.viewPermission);
            let additionalViewPermission = Utils.convertJSONDataToObject(
                detailTicket.additionalViewPermission
            );
            
            if (!Utils.isEmptyObject(additionalViewPermission)) {
                let b2bCustomerProject = !Utils.isEmptyArray(
                    additionalViewPermission.b2bCustomerProject
                )
                    ? additionalViewPermission.b2bCustomerProject
                    : [];
                let b2bHelpdeskProject = !Utils.isEmptyArray(
                    additionalViewPermission.b2bHelpdeskProject
                )
                    ? additionalViewPermission.b2bHelpdeskProject
                    : [];
  
                let baseProject = !Utils.isEmptyArray(additionalViewPermission.baseProject)
                    ? additionalViewPermission.baseProject
                    : [];
  
                let guestCustomerProject = !Utils.isEmptyArray(
                    additionalViewPermission.guestCustomerProject
                )
                    ? additionalViewPermission.guestCustomerProject
                    : [];
  
                let orgProject = !Utils.isEmptyArray(additionalViewPermission.orgProject)
                    ? additionalViewPermission.orgProject
                    : [];
  
                projectList = [
                    ...b2bCustomerProject,
                    ...b2bHelpdeskProject,
                    ...baseProject,
                    ...guestCustomerProject,
                    ...orgProject
                ];
            }

            if (!Utils.isEmptyArray(viewPermission)) {
                viewPermission?.forEach(permission => {
                    if (permission === Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR_ONLY) {
                        userHasReadPermission.push(detailTicket.creator);
                    }
                    if (permission === Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT) {
                        projectList.push(detailTicket.affiliationProject);
                    }
                    if (permission === Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG) {
                        orgHasReadPermission.push(detailTicket.affiliationOrganization);
                    }
                    if (permission === Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_CUSTOMER) {
                        let activeB2BCustomerList = Utils.convertJSONDataToObject(
                            detailTicket.activeB2BCustomerList
                        );
                        if (!Utils.isEmptyArray(activeB2BCustomerList)) {
                            projectList = [...projectList, ...activeB2BCustomerList];
                        }
                    }
                    if (permission === Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_SUPPORT) {
                        let activeB2BSupportList = Utils.convertJSONDataToObject(
                            detailTicket.activeB2BSupportList
                        );
                        if (!Utils.isEmptyArray(activeB2BSupportList)) {
                            projectList = [...projectList, ...activeB2BSupportList];
                        }
                    }
                    if (permission === Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC) {
                        uriObj.publicAll = true;
                    }
                });

                uriObj.projectList = projectList;
                uriObj.orgHasReadPermission = orgHasReadPermission;
                uriObj.userHasReadPermission = userHasReadPermission;
                uriObj.keyFile = `/public/${s3Path}`;

            }

        } else {
            let isShareForProjectOrigin = true;
            if (
                fileUpload.chatThreadType === Constant.THREAD_TYPE.CUSTOMER &&
                'user' === Utils.getPrefixOfId(detailTicket.customer)
            ) {
                isShareForProjectOrigin = false;
            }
            const sharedRange = JSON.parse(fileUpload.sharedRange);
            for (const key in sharedRange) {
                let sharedProjectList = Object.keys(sharedRange[key]);
                projectList = [...projectList, ...sharedProjectList];
            }
            if (!isShareForProjectOrigin) {
                if (projectList.includes(detailTicket.projectOrigin)) {
                    const index = projectList.indexOf(detailTicket.projectOrigin);
                    if (index > -1) {
                        projectList.splice(index, 1);
                    }
                }
                userHasReadPermission.push(detailTicket.customer);
            }
            uriObj = {
                projectList,
                orgHasReadPermission,
                userHasReadPermission,
                keyFile: `/public/${s3Path}`
            };
        }
    }
    
    if (isPublic) {
        uriObj.publicAll = true;
    }

    if (pksAffiliationProject) {
        uriObj.viewFromPKS = true;
        uriObj.affiliationProject = pksAffiliationProject;
    }

    uriObj.affiliationOrganization = detailTicket.affiliationOrganization;

    // Cache-busting: if file was recently replaced, force CloudFront to fetch from S3 origin
    const replacedTimestampMap = getRecoil(replacedFileTimestampMapAtom);
    if (replacedTimestampMap?.[fileUpload?.fileUrl]) {
        uriObj.noCache = true;
        uriObj.timeStamp = replacedTimestampMap?.[fileUpload?.fileUrl];
    }

    const enCodeUriObj = encodeURIComponent(
        crypto.AES.encrypt(JSON.stringify(uriObj), Constant.S3_URL_AES_ENCODE_KEY).toString()
    );
    const newUri = `/${enCodeUriObj}`;
    if(s3Path === '/assets/image/thumbnail.png'){
        return s3Path
    }
    return `${process.env.REACT_APP_CLOUD_FRONT_URL}${newUri}`;
};

export const downloadFileFromS3 = async (fileUpload, detailTicket, isDownloadPublicAttachment = false, isPdfFile = false, pksAffiliationProject = '', setIsShowPopupLogout) => {
    
    // get value cookie verifyAccessS3
    let verifyAccessS3Value = getCookieValue('verifyAccessS3');
    if (!verifyAccessS3Value && setIsShowPopupLogout) {
        setIsShowPopupLogout(true);
        return;
    }
    
    let dataDownload = getLinkDownloadFileFromS3(fileUpload, detailTicket, null, null, true, isDownloadPublicAttachment, pksAffiliationProject);
    
    if(detailTicket.ticketType === Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE){
        dataDownload = `${dataDownload}#page=${detailTicket.pageNo}`
    }
    const a = document.createElement('a');
    a.href = dataDownload;
    a.download = fileUpload.content;
    a.target = '_blank';
    a.click();
    a.remove();
};

export const getFileSizeDisplay = (totalByte) => {
    if (!totalByte) return '0';
    if (totalByte < 1024) {
        return `${totalByte} bytes`;
    }
    let num = totalByte / 1024;
    if (totalByte < 1024 * 1024) {
        return `${Math.round(num * 100) / 100} KB`;
    }
    num = num / 1024;
    if (totalByte < 1024 * 1024 * 1024) {
        return `${Math.round(num * 100) / 100} MB`;
    }
    num = num / 1024;
    return `${Math.round(num * 100) / 100} GB`;
};
